/**
 * Returns a number with the specified number of decimals
 * When not a number is given, returns the original value
 * @param {Number} number
 * @param {Number} decimals
 * @returns {Number}
 */
export function numberFixDecimals (number, decimals = 2) {
  if (!Number.isFinite(parseFloat(number))) return number
  return parseFloat(number.toFixed(decimals))
}
